export const ClientToken = "enlis_token";
export const ClientRefreshToken = "enlis_refresh_token";
export const ClientSelectedProgram = "enlis_program";
export const ClientDetail = "enlis_user";
export const FacilityType = "facility_type";

export const pageSizeOptions = ["5", "10", "20", "50", "100", "200"];
export const defaultPageSize = 10;
export const defaultDebounceTime = 1000; // milliseconds

export const dateTypeEnums = {
  DATE_TIME: "YYYY-MM-DD hh:mm:ss",
  DATE: "YYYY-MM-DD",
  DMMMYY: "D MMM, YYYY",
  DMMMYYYY: "D MMM, YYYY",
  TIME: "hh:mm:ss",
  DATE_TIME_SHORT: "DD/MM/YYYY hh:mm",
  DATE_TIME_AM_PM: "DD/MM/YYYY hh:mma",
  DATE_MMM_TIME_AM_PM: "DD/MMM/YYYY hh:mma",
  MONTH: "MMM YYYY",
  WEEK: "[Week] w, YYYY",
  DDMMMYYYY_TIME: "DD-MMM-YYYY HH:mm",
};

export const dispatchStatusEnum = {
  PENDING: 7,
  FACILITY_NOTIFIED: 1,
  COURIER_NOTIFIED: 2,
  DISPATCHED: 3,
  DELIVERED: 4,
  RECEIVED: 5,
  REJECTED: 6,
  CANCELLED: 7,
};

export const identifierEnum = {
  EPID_NUMBER: "EPID Number",
  HOSPITAL_NUMBER: "Hospital Number",
  DR_REGISTER_NUMBER: "DR Register Number",
  LGA_TB_NUMBER: "LGA TB Number",
  PHONE_NUMBER: "Phone Number",
  LAB_NUMBER: "Lab Number",
  EMAIL_ADDRESS: "Email Address",
};

export const baseRoute = import.meta.env.PROD === "production" ? "" : "enlis/";

export const UserRoleEnums = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  SUPERVISOR: "Supervisor",
  MANAGER: "Manager",
  ANALYST: "Analyst",
  DATA_CLERK: "Data Clerk",
  RECEPTIONIST: "Receptionist",
  DATA_ANALYST: "Data Analyst",
  TIER_USER: "Government Tier Officer",
  SENIOR_MOLECULAR_BIOLOGIST: "Senior Molecular Biologist",
  SAMPLE_COLLECTOR_SUPERVISION: "Sample Collector Supervision",
  SAMPLE_COLLECTOR: "Sample Collector",
  SORMAS: "SORMAS",
  PRINICPAL_INVESTIGATOR: "Principal Investigator",
  
};

export const FacilityTypeEnums = {
  PUBLIC: "public",
  PRIVATE: "private",
  CLINICAL: "clinical",
  REFERRAL: "referral",
};

export const displayTypeEnums = {
  GRID: "grid",
  LIST: "list",
  TABLE: "table",
};

export const API_URL = {
  NON_CONFORMITY: "non_conformity_report/",
  PROGRAMS: "program/",
  FOLDERS: "folders/",
  FILES: "files/",
  RECENT_FILES: "folders/recent_files/",
  RECENT_FOLDERS: "folders/recent_folders/",
  WORK_SHEET_ARCHIVES: "sample_worksheet/",
  PENDING_CONSUMABLES: "consumable/",
  CONFIG_CONSUMABLES: "consumable_config/",
  RECEIVED_CONSUMABLES: "received_consumable/",
  CONSUMABLE_GENERIC: "consumable_generic/",
  ASSETS: "asset/",
  ASSETS_CONFIG: "asset_config/",
  ASSETS_GENERIC: "asset_generic/",
  SUPPLIER: "supplier/",
  MANUFACTURER: "manufacturer/",
  MEASURE_UNIT: "measure_unit/",
  FACILITY_USERS: "facilities/facility-users/",
  FACILITIES: "facilities/",
  TEST_STATUS_COUNT_GENERAL: "general_order_count/",
  TEST_STATUS_COUNT_PH: "public_health_count",
  USER_LIST: "users/",
  DISABLE_ENABLE_USER: (id) => `users/${id}/disable_enable/`,
  CLIENTS: "clients/",
  UPDATE_CLIENT: (id) => `clients/${id}/`,
  DASHBOARD: {
    TIER_GENERAL: "tier_general_order_dashboard/",
    GLOBAL_DASHBOARD: "global_dashboard/",
    TIER_PROGRAM: "tier_general_program_dashboard/",
    USER_LOCATION_LOOKUP: "user_location_look_up/",
    DASHBOARD_FILTER: "dashboard_filter/",
    MONITORING_DASHBOARD: "/monitoring/dashboard/", 
    MONITORING_SAMPLES: "/monitoring/samples/",
  },

  ESPN: {
    SAMPLE_PREPROCESSING: "sample-preprocessing/",
    SAMPLE_COLLECTION: "sample-collection/",
    SAMPLE_EXTRACTION: "sample-extraction/",
    INCIDENCE_REPORTING: "incidence-reporting/",
    SAMPLE_COLLECTION_SUPERVISION: "sample-collection-supervision/",
    SAMPLE_RECEPTION: "sample-reception/",
    SAMPLE_SUBMISSION: "sample-submission/",
    LABORATORY_RESULTS: "laboratory-results/",
    MOORE_SWAB_DEPLOYMENT: "moore-swab-deployment/",
    EN_SITES: "es-sites/",
    SERVICING: "servicing/",
    EQUIPMENT_DECONTAMINATION: "equipment-decontamination/",
    DASHBOARD_STATS: "espn-dashboard/stats/",
    DASHBOARD_SUMMARY: "espn-dashboard/summary/",
    DASHBOARD_EXPORT: "espn-dashboard/export/",
    SAMPLE_TYPE: "sample_type/",
  },
};

export const QueryKeysEnums = {
  NON_CONFORMITY_LIST: "non_conformity_list",
  FOLDERS: "folders",
  FILES: "files",
  RECENT_FILES: "recent_files",
  RECENT_FOLDERS: "recent_folders",
  WORK_SHEET_ARCHIVES: "work_sheet_archives",
  PENDING_CONSUMABLES: "pending_consumables",
  CONFIG_CONSUMABLES: "config_consumables",
  RECEIVED_CONSUMABLES: "received_consumables",
  CONSUMABLE_GENERIC: "consumable_generic",
  MANUFACTURER: "manufacturer",
  MEASURE_UNIT: "measure_unit",
  ASSETS: "assets",
  FACILITY_USERS: "facility_users",
  FACILITIES: "facilities",
  TEST_STATUS_COUNT: "test_status_count",
  USERS: "users/",
  ESPN_RECORDS: "espn_records",
};

export const unAuthorizedRoutes = [
  "/",
  "/signin",
  "/signup",
  "/terms",
  "/reset-password",
  "/forgot-password",
];

export const isDev = import.meta.env.MODE === "development";
export const isTestMode = import.meta.env.MODE === "test";
export const isProductionMode = import.meta.env.MODE === "production";
export const isNcdcMode = import.meta.env.VITE_APP_ENV === "ncdc";

export const userLocationEnums = {
  FEDERAL: 1,
  STATE: 2,
  LGA: 3,
  FACILITY: 4,
};
 
/**
 * Programs that need special routing. Kept as an enum rather than a bare 7 so
 * the dashboard dispatch branch reads as intent instead of a magic number.
 *
 * VERIFY: 7 is taken from the existing `queryRecord?.program === 7` check in
 * TestsContent. Confirm it matches the Program row named "General" — the
 * backend's own General check compares on NAME, so if the ID and the name ever
 * disagree, the two halves of the system will disagree with them.
 */
export const programEnums = {
  GENERAL: 7,
};

